import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, filter, take } from 'rxjs/operators';
import { PermissionService } from './core/services/permission.service';
import { UserService } from './core/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AppGuard implements CanActivate {
  private userService = inject(UserService);
  private permissionService = inject(PermissionService);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.userService.currentUser$.pipe(
      filter((user) => user !== undefined), // wait until we actually know if user exists or not
      take(1),
      switchMap((user) => {
        if (!user?.id) {
          this.router.navigateByUrl('/account');
          return of(false);
        }

        // Wait until permission$ emits a non-null value
        return this.permissionService.permission$.pipe(
          filter((res) => res !== undefined && res !== null),
          take(1),
          map((res) => {
            return !!res; // true if permission exists
          }),
          catchError(() => {
            return of(false);
          })
        );
      })
    );
  }
}
